import { registerLocaleData } from '@angular/common';

const resolve = async (locale: string) => {
  switch (locale) {
    case 'de':
      return import('@angular/common/locales/de');
    case 'nl':
      return import('@angular/common/locales/nl');
    case 'fr':
      return import('@angular/common/locales/fr');
    case 'sv':
      return import('@angular/common/locales/sv');
    case 'fi':
      return import('@angular/common/locales/fi');

    case 'en':
    default:
      return import('@angular/common/locales/en');
  }
};

export const loadAngularTranslations = async (locale: string) =>
  resolve(locale).then(m => registerLocaleData(m.default));
